export default "__VITE_ASSET__011b9314__"